import * as Sentry from "@sentry/browser";
import ReactDOM from "react-dom/client";
import "@/index.css";
import restrictKeys from "@/core/helpers/restrictKeys.ts";
import "@/i18n/config.ts";
import App from "@/App";

restrictKeys(); // Restrict Tilda Key "`" for using because it uses by Client for show&hide cursor

const isProduction = import.meta.env.MODE !== "development";
const sentryDSN = import.meta.env.VITE_SENTRY_DSN;
const release = import.meta.env.VITE_APP_VERSION;

if (sentryDSN && isProduction) {
  Sentry.init({
    dsn: sentryDSN,
    release,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
